import httpService from "services/api.service";

const BASE_URL = "/stock_history_detail";

export const getDetailRiwayatStok = async (query) => {
  try {
    const res = await httpService.get(`${BASE_URL}${query}`);
    return res;
  } catch (error) {
    throw error.message;
  }
};
